/**
 * @generated SignedSource<<8fd8132a1e2478790278ab4f047e2923>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespSharedCarouselItemTile_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ItemTile_viewer">;
  readonly " $fragmentType": "PdpRespSharedCarouselItemTile_viewer";
};
export type PdpRespSharedCarouselItemTile_viewer$key = {
  readonly " $data"?: PdpRespSharedCarouselItemTile_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSharedCarouselItemTile_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSharedCarouselItemTile_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ItemTile_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "cee2e47d17928febe2b71e84459ce4ea";

export default node;
